interface TicketCardShimmerProps {
  className?: string;
}

const shimmerGradient =
  "bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] animate-pulse";

export const TicketCardShimmer = ({ className = "" }: TicketCardShimmerProps) => {
  return (
    <div
      className={`bg-pure-white dark:bg-pure-white-dk border border-border-gray dark:border-border-gray-dk rounded-lg w-[280px] overflow-hidden ${className}`}
    >
      <div className="flex flex-col gap-[10px] px-3 py-[10px]">
        {/* Title */}
        <div className="w-full min-h-[26px] flex flex-col gap-1">
          <div className={`h-4 w-[85%] rounded ${shimmerGradient}`} />
          <div className={`h-4 w-[55%] rounded ${shimmerGradient}`} />
        </div>

        {/* Priority + chat count + client code row */}
        <div className="flex flex-wrap gap-3 items-center w-full">
          <div className="flex gap-[2px] items-center">
            <div className={`w-3 h-3 rounded ${shimmerGradient}`} />
            <div className={`h-3.5 w-12 rounded ${shimmerGradient}`} />
          </div>
          <div className="h-[10px] w-px bg-border-gray dark:bg-border-gray-dk shrink-0" />
          <div className="flex gap-[2px] items-center">
            <div className={`w-3 h-3 rounded ${shimmerGradient}`} />
            <div className={`h-3 w-4 rounded ${shimmerGradient}`} />
          </div>
          <div className="h-[10px] w-px bg-border-gray dark:bg-border-gray-dk shrink-0" />
          <div className={`h-5 w-[90px] rounded-[5.455px] ${shimmerGradient}`} />
        </div>

        {/* Tags row */}
        <div className="flex gap-[6px] items-center w-full">
          <div className={`h-[22px] w-14 rounded ${shimmerGradient}`} />
          <div className={`h-[22px] w-16 rounded ${shimmerGradient}`} />
          <div className={`h-[22px] w-10 rounded ${shimmerGradient}`} />
        </div>

        {/* Property + category + ticket ID row */}
        <div className="flex items-center gap-[6px]">
          <div className={`h-3.5 w-16 rounded ${shimmerGradient}`} />
          <div className="h-[10px] w-px bg-border-gray dark:bg-border-gray-dk shrink-0" />
          <div className={`h-3.5 w-14 rounded ${shimmerGradient}`} />
          <div className="h-[10px] w-px bg-border-gray dark:bg-border-gray-dk shrink-0" />
          <div className={`h-3.5 w-10 rounded ${shimmerGradient}`} />
        </div>

        {/* Assignee + last activity row */}
        <div className="flex items-center justify-between w-full">
          <div className="flex gap-1 items-center">
            <div className={`w-[18px] h-[18px] rounded-full ${shimmerGradient}`} />
            <div className={`h-3.5 w-20 rounded ${shimmerGradient}`} />
          </div>
          <div className={`h-3.5 w-24 rounded ${shimmerGradient}`} />
        </div>
      </div>
    </div>
  );
};
